import React from 'react';

const SlideIndicators = ({ currentSlide, totalSlides, onSlideSelect }) => {
  return (
    <div className="flex justify-center space-x-2 py-4">
      {Array.from({ length: totalSlides }, (_, index) => (
        <button
          key={index}
          onClick={() => onSlideSelect(index + 1)}
          className={`w-3 h-3 rounded-full nav-transition ${
            currentSlide === index + 1
              ? 'bg-primary' :'bg-border hover:bg-border-light'
          }`}
          aria-label={`Go to slide ${index + 1}`}
        />
      ))}
    </div>
  );
};

export default SlideIndicators;